module.exports = __webpack_public_path__ + "media/images/gift_plan/bubble-img-otoku-3month-428a85c4e580d1392bd81394a2c86593.png";